import { Component, OnInit } from '@angular/core';
import { OrderMenu } from '../../_models/orderMenu';
import { AfterViewInit, OnDestroy, ViewChild } from '@angular/core';
import { DataTableDirective } from 'angular-datatables';
import { ActivatedRoute, Router } from "@angular/router";
import { Subject } from 'rxjs';
import { Globals } from '../../_models/globals';
import { AlertService } from '../../_services/alert.service';
import { ApiIntegration } from '../../_services/api.integration';
import { environment } from '../../../environments/environment';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
//import { LocalStorageService, SessionStorageService, LocalStorage, SessionStorage } from 'angular-web-storage';

@Component({
  selector: 'app-finance-cod-orders',
  templateUrl: './finance-cod-orders.component.html',
  styleUrls: ['./finance-cod-orders.component.scss'],
})
export class FinanceCODOrdersComponent implements OnInit {
  ordersMainMenu: OrderMenu[] = [
    {
      displayName: "All", tabClicked: "all", orderStatus: "ALL", additional: "N"
    },
    {
      displayName: "To be Paid", tabClicked: "toBePaid", orderStatus: "TO_BE_COLLECTED", additional: "N"
    },
    {
      displayName: "Paid", tabClicked: "paid", orderStatus: "PAID", additional: "N"
    },
    {
      displayName: "Remittance", tabClicked: "remittance", orderStatus: "REMITTANCE", additional: "N"
    },
  ];
  @ViewChild(DataTableDirective, { static: false })
  dtElement: DataTableDirective;
  dtOptions: DataTables.Settings = {};
  dtInstance: DataTables.Api;
  dtTrigger = new Subject();
  orderStatus: any = 'TO_BE_PAID';
  checkedList2 = [];
  tabClicked: any = "all";
  previousStatus = '';
  totalCount = 0;
  checkedListView = [];
  checkedOrderIdList = [];
  masterSelected: boolean = false;
  name: any;
  checkboxDisplay: any = 'N';
  accountOwners: any;
  //paidList : any;
  //toBePaidList : any;
  checkedList: any;
  orders: any;
  ord : any;


  constructor(private http: HttpClient, private alertService: AlertService, private router: Router, private api: ApiIntegration, public g: Globals) {
    this.getNames();
    /*     if(this.tabClicked == 'toBePaid'){
          this.toBePaid();
        }
        else{
        this.paid();
        } */

    this.tabClicked = this.g.pageTab;
    if (this.g.pageTab !== null && this.g.pageTab !== undefined) {
      this.tabClicked = this.g.pageTab;
      for (let ol of this.ordersMainMenu) {
        if (ol.tabClicked === this.g.pageTab) {
          this.populateTabData(this.g.pageTab, ol.orderStatus);
          this.switchPosition(ol);
        }
      }
    } else {
      this.tabClicked = "all";
      this.populateTabData('all', "ALL");
    }

  }

  getNames() {
    this.api.getAllCustomersListAndSellerList().subscribe((data: any) => {
      this.accountOwners = data.sellerResponseList;
    }, err => {
      this.alertService.error('Error', err);
    });
  }

  switchPosition(om) {
    let index = this.ordersMainMenu.indexOf(om);
    om.additional = 'N';
  }

  populateTabData(triggered, orderStatus) {
    this.tabClicked = triggered;
    this.orderStatus = orderStatus;
    this.name = {};
    if (!this.previousStatus) {
      this.getCODOrders(orderStatus);
    } else {
      this.rerender();
    }
  }

  customSearchFn(term: string, item: any = []) {
    term = term.toLowerCase();
    return item.name.toLowerCase().indexOf(term) > -1 || (item.companyName && item.companyName.toLowerCase().indexOf(term) > -1);
  }


  resetCheckedList() {
    this.masterSelected = false;
    this.checkedList2 = [];
    this.checkedOrderIdList = [];
    this.checkedListView = [];
  }

  ngOnInit() { }

  ngAfterViewInit(): void {
    this.dtTrigger.next(true);
  }
  rerender(): void {
    this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
      dtInstance.destroy();
      this.dtTrigger.next(true);
    });
  }

  tabChange() {
    this.checkedList2 = [];
    this.g.loaderDisplay = "";
  }

  getCODOrders(status) {
    this.checkboxDisplay = 'N';
    this.dtOptions = {
      "ordering": false,
      pagingType: 'full_numbers',
      lengthMenu: [20, 50, 100, 200],
      pageLength: 20,
      language: {
        searchPlaceholder: 'Search by Order #'
      },
      serverSide: true,
      ajax: (dataTablesParameters: any, callback) => {
        if (this.previousStatus !== this.orderStatus) {
          dataTablesParameters.start = 0;
          this.previousStatus = this.orderStatus;
        }
        let apiMethod = 'api/getOrderConsignmentsByStatusCod'
        let query: any = {
          status: this.orderStatus,
          orderType: 'ORDER',
          organizationId: 1,
          paymentMethod: 'COD',
          page: dataTablesParameters.start ? (dataTablesParameters.start / dataTablesParameters.length) : dataTablesParameters.start,
          size: dataTablesParameters.length
        }
       /*  if (this.tabClicked !== 'all') {
          let query: any = {
            status: this.orderStatus,
            page: dataTablesParameters.start ? (dataTablesParameters.start / dataTablesParameters.length) : dataTablesParameters.start,
            size: dataTablesParameters.length
          }
        } */
        if ((dataTablesParameters.search || {}).value && (dataTablesParameters.search || {}).value.trim() !== '') {
          query.searchString = dataTablesParameters.search.value.trim();
        }

        this.g.loaderDisplay = "display";
        var header1 = new HttpHeaders();
        header1 = header1.append('Content-Type', 'application/json');
        header1 = header1.append('Accept', 'application/json');
        header1 = header1.append('Authorization', 'Bearer ' + localStorage.getItem('jwt'));
        this.http.get(environment.apiUrl + apiMethod, {
          params: query,
          headers: header1
        }).subscribe((resp: any) => {
        this.ord = resp;
          this.orders = resp.ordersData;
          this.g.loaderDisplay = "";
          this.orders.forEach((s) => {
            s['isSelected'] = false;
          });
          callback({
            recordsTotal: resp.noOfRecords,
            recordsFiltered: resp.noOfRecords
          });
        },
          (err) => {
            this.g.loaderDisplay = "";
            this.alertService.error('Error', err);
          });
      }
    };
  }

  paymentProcess() {
    this.router.navigate(['/admin/codOrdersPaymentProcessing']);
  }

  selectShip(sl) {
    if (!sl.isSelected) {
      this.masterSelected = false
    }
    this.getCheckedShipList();
  }

  getCheckedShipList() {
    this.g.ordersIds = [];
    this.g.amountValues = [];

    for (var i = 0; i < this.orders.length; i++) {
      if (this.orders[i].isSelected) {
        this.g.ordersIds.push(this.orders[i]['orderNumber']);
        this.g.amountValues.push(this.orders[i]['orderAmount']);
        this.g.codAccountOwnerName = this.orders[0].userName;
      }
    }
  }

  getApiData(orderStatus) {
    if (this.name.id != null && this.tabClicked == 'all') {
      this.g.loaderDisplay = "display";
      if(this.orderStatus == 'TO_BE_COLLECTED') {
      this.orderStatus = 'TO_BE_PAID';
      }
      this.api.getCodOrdersForFinance(this.name.id, "ORDER", "1", this.orderStatus).subscribe((data: any) => {
        this.g.loaderDisplay = "";
        this.orders = data.ordersData;
        this.checkboxDisplay = 'Y';
      },
        err => {
          this.g.loaderDisplay = "";
          this.alertService.error('Error', err);
        });
    } else if (this.name.id != null && this.tabClicked !== 'all') {
      this.g.loaderDisplay = "display";
      this.api.getAccountOwnerData(this.name.id, this.name.accountType, this.orderStatus).subscribe((data: any) => {
        this.g.loaderDisplay = "";
        this.orders = data.codOrders;
        this.checkboxDisplay = 'Y';
      },
        err => {
          this.g.loaderDisplay = "";
          this.alertService.error('Error', err);
        });
    }
  }

  saveCodInfo() {
    this.g.loaderDisplay = "display";
    var header1 = new HttpHeaders();
    header1 = header1.append('Content-Type', 'application/json');
    header1 = header1.append('Accept', 'application/json');
    header1 = header1.append('Authorization', 'Bearer ' + localStorage.getItem('jwt'));
    this.http.post(environment.apiUrl + 'api/savePaymentInfoForCODOrder', {
      "orderNumber": this.g.ordersIds,
      "remittanceRefDate": '',
      "remittanceRefNum": ''
    },
      { headers: header1 }).subscribe((data: any) => {
        this.g.loaderDisplay = "";
        if (data['code'] == 200) {
          this.alertService.success('Cod Info', 'Updated Successfully');
        } else {
          this.alertService.error('Error', data['message']);
        }
        this.g.loaderDisplay = "";
      },
        (err: HttpErrorResponse) => {
          this.g.loaderDisplay = "";
          console.log(err);
        });
  }

}
